export function navItemTemplate(
	path: string,
	title: string,
	icon: string,
): string {
	return `
        <li class="nav-list-item">
            <a href="${path}" data-route="${path}" class="nav-list-item-link"${path === '/activity' ? ` data-friend-request-indicator="${title}"` : ''}>
                <span class="tooltip">${title}</span>
                <svg class="nav-list-item-icon"><use href="${icon}"></use></svg>
            </a>
        </li>
    `
}

export function navTemplate(
	itemsHtml: string,
	backButtonHtml: string,
	scrollTopButtonHtml: string,
): string {
	return `
        <div id="navigation">
            <nav class="liquid-nav">
                <ul class="nav-list">
                    ${itemsHtml}
                </ul>
				<div class="nav-floating-slot">
					${scrollTopButtonHtml}
					${backButtonHtml}
				</div>
            </nav>
        </div>
    `
}
